import React from 'react';
import { Menu } from '@components';
import './header.scss';

export const Header = (): JSX.Element => (
  <header className="header">
    <Menu />
  </header>
);
